import { Component, Inject, ViewEncapsulation } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';

export interface ConfirmDialogData {
  titleKey: string;
  messageKey: string;
  messageParams?: any[];
  confirm: () => void;
}

@Component({
  selector: 'app-task-processing-hint-dialog',
  templateUrl: 'task-processing-hint-dialog.component.html',
  styleUrls: ['task-processing-hint-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TaskProcessingHintDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<TaskProcessingHintDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translationService: TranslationService) {}

  close() {
    this.dialogRef.close();
  }

}
